<template>
  <div
    class="progress-container"
    v-if="initialLoading">
    <v-progress-circular
    :size="120"
    color="primary"
    indeterminate
    ></v-progress-circular>
  </div>
  <v-layout v-else>
    <v-flex sm6 class="text-xs-center text-sm-left">
      <v-card-title class="display-1 font-weight-thin">{{ $t('templates.upload.fields-to-use') }}</v-card-title>
      {{ $t('schema.builder.print.field-drop.fields-declared') }}
      <ul class="font-weight-light">
        <li v-for="(field, index) in schema.fields"  :key="index">
          <hint :field="field"></hint>
        </li>
      </ul>
      {{ $t('schema.builder.print.field-drop.generated-elements') }}
      <ul class="font-weight-light">
        <li>{{ $t('templates.generated.signature' )}} - <b>${gsignature}</b></li>
        <li>{{ $t('templates.generated.completion_date' )}} - <b>${gcompletion_date}</b></li>
        <li>{{ $t('templates.generated.creator' )}} - <b>${gcreator}</b></li>
        <li>{{ $t('templates.generated.created_at' )}} - <b>${gcreated_at}</b></li>
        <template v-if="schema.type == schemaType.TEST">
          <li>{{ $t('agency.agency' )}} - <b>${gagency}</b></li>
          <li>{{ $t('base.lang' )}} - <b>${glanguage}</b></li>
          <li>{{ $t('test.score' )}} - <b>${gpoints}</b></li>
          <li>{{ $t('test.passed' )}} - <b>${gpassed}</b></li>
        </template>
        <template v-if="schema.confirmation === 1">
          <li>{{ $t('templates.generated.confirmator' )}} - <b>${gconfirmator}</b></li>
          <li>{{ $t('templates.generated.confirmed_at' )}} - <b>${gconfirmed_at}</b></li>
        </template>

      </ul>
    </v-flex>
    <v-divider
      class="mx-4"
      inset
      vertical
    ></v-divider>
      <v-flex sm4 class="text-xs-center text-sm-left">
      <v-card-title class="display-1 font-weight-thin">{{ $t('templates.upload.add-template') }}</v-card-title>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation>
        <v-text-field
          :label="`${$t('templates.upload.select-file')}`"
          @click='pickFile'
          :rules="fileRules"
          required
          v-model='docName'
          prepend-icon='attach_file'>
        </v-text-field>
        <input
          type="file"
          style="display: none"
          ref="doc"
          accept=".docx"
          @change="onFilePicked" />
        <v-text-field
          :label="`${$t('templates.upload.name')}`"
          :rules="nameRules"
          required
          v-model="name">
        </v-text-field>
        <v-progress-circular
          v-if="loading"
          indeterminate
          style="margin-right: 10px"
          ></v-progress-circular>
        <v-btn
          color="blue-grey"
          dark
          :disabled="loading || !valid"
          round
          @click="upload">
          <span style="margin-right: 10px; font-weight: bold; color: #efefef">{{ $t('templates.upload.send') }}</span>
          <v-icon small>send</v-icon>
        </v-btn>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import http from '@/plugins/http'
import hint from './Hint'
import schemaType from "@/enums/schemaType";

export default {
  components: { "hint": hint },
  data: () => ({
    schemaType,
    valid: true,
    docName: '',
    docFile: '',
    name: '',
    schema: null,
    initialLoading: false,
    loading: false
  }),
  computed: {
    fileRules() {
      return [
        v => !!v || this.$t('templates.upload.rules.required'),
        v => /.+\.docx/.test(v) || this.$t('templates.upload.rules.extension')
      ]
    },
    nameRules() {
      return [
        v => !!v || this.$t('templates.upload.rules.required')
      ]
    }
  },
  created() {
    this.initialLoading = true
    http.get('schema/' + this.$route.params.schemaId).then(response => {
      this.schema = response.data
      this.initialLoading = false
    })
  },
  methods: {
    pickFile () {
      this.$refs.doc.click ()
    },
    onFilePicked (e) {
      const files = e.target.files
      const regex = /^(.*?)\./;
      if(files[0] !== undefined) {
        this.docName = files[0].name
        let matches = regex.exec(this.docName)
        if(this.name == "") {
          this.name = matches[1]
        }
        if(this.docName.lastIndexOf('.') <= 0) {
          return
        }
        const reader = new FileReader ()
        reader.readAsDataURL(files[0])
        reader.addEventListener('load', () => {
          this.docFile = files[0]
        })
      } else {
        this.docName = ''
        this.docFile = ''
      }
    },
    upload () {
      if (this.$refs.form.validate()) {
        this.loading = true
        var data = new FormData()
        data.append("name", this.name)
        data.append("schema_id", this.$route.params.schemaId)
        data.append("status", 1)
        data.append("template", this.docFile)
        http.post('template/upload', data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(() => {
          this.loading = false
          this.$store.commit('setSnack', {
            message: this.$t('templates.upload.success-message'),
            color: 'success'
          })
          this.$router.push({ name: 'schema-templates', params: { schemaId: this.$route.params.schemaId } })
        }).catch(() => {
          this.loading = false
          this.$store.commit('setSnack', {
            message: this.$t('templates.upload.error-message'),
            color: 'warning'
          })
        })
      }
    }
  },
}
</script>

<style>
</style>
